import { Module } from '@nestjs/common'
import { BookingServerController } from './booking-server.controller'
import { BookingServerService } from './booking-server.service'
import { ReservationSharedModule } from '../../../shared'

@Module({
	imports: [ReservationSharedModule],
	controllers: [BookingServerController],
	providers: [BookingServerService],
})
export class GoogleReservationsBookingServerModule {}
